module.exports = __webpack_public_path__ + "static/img/img_s.44ffcb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_s.jpg
// module id = jsdk
// module chunks = 2